var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDominica(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1306 31.693C25.4558 30.4383 30.4384 25.4556 31.6931 19.1305H19.1306V31.693Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.307007 19.1305C1.56169 25.4556 6.54432 30.4383 12.8695 31.693V19.1305H0.307007Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6931 12.8695C30.4384 6.54435 25.4558 1.56173 19.1306 0.306976V12.8695H31.6931Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8695 0.306976C6.54432 1.56173 1.56169 6.54435 0.307007 12.8695H12.8695V0.306976Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9564 19.1305H12.8695V31.693C13.5506 31.8281 14.2473 31.9196 14.9564 31.9653V19.1305Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9564 12.8694V0.0346985C14.2473 0.0803235 13.5505 0.171886 12.8695 0.306948V12.8694H14.9564Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0438 0.0348125C16.6987 0.0125 16.351 0 16.0003 0C15.6496 0 15.3019 0.0125 14.9568 0.0348125V12.8696H17.0437V0.0348125H17.0438Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9568 31.9653C15.3019 31.9876 15.6496 32.0001 16.0003 32.0001C16.351 32.0001 16.6987 31.9876 17.0438 31.9653V19.1305H14.9568V31.9653H14.9568Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8699 14.9564V12.8695H0.307406C0.172281 13.5506 0.0807813 14.2472 0.0351562 14.9564H12.8699Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1305 14.9564H31.9653C31.9197 14.2472 31.8281 13.5506 31.6931 12.8695H19.1306V14.9564H19.1305Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1305 17.0433H31.9653C31.9876 16.6982 32.0001 16.3505 32.0001 15.9998C32.0001 15.6491 31.9876 15.3014 31.9652 14.9563H19.1305V17.0433Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0348125 14.9563C0.0125625 15.3014 0 15.6491 0 15.9998C0 16.3505 0.0125625 16.6982 0.0348125 17.0433H12.8696V14.9564H0.0348125V14.9563Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 23.6522C20.2258 23.6522 23.6518 20.2262 23.6518 16.0001C23.6518 11.7739 20.2258 8.34787 15.9996 8.34787C11.7734 8.34787 8.34741 11.7739 8.34741 16.0001C8.34741 20.2262 11.7734 23.6522 15.9996 23.6522Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7434 16.8537C17.1742 15.7154 16.4344 14.5616 16.4344 14.5616C16.4344 14.5616 16.4528 14.0363 16.4528 13.7233C16.4528 13.2518 16.0706 12.8696 15.5991 12.8696C15.1524 12.8696 14.7864 13.2128 14.7491 13.6497C14.3978 13.6726 14.1199 13.964 14.1199 14.321C14.1199 14.5806 14.2669 14.8055 14.4822 14.9179C14.5892 14.6677 14.7987 14.4723 15.0578 14.3833C15.1001 14.4178 15.1454 14.4487 15.1939 14.4749L15.3032 14.5273C15.3032 14.5273 14.8977 15.6704 14.8977 16.2846C14.8977 18.0111 16.0361 18.5435 16.0361 18.5435V18.5613L15.4669 19.1304H16.6052V17.9921L17.1744 18.5613C17.1794 18.5506 18.2525 17.8719 17.7434 16.8537V16.8537Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 9.73895L16.2597 10.5361H17.0978L16.4198 11.0288L16.6788 11.8259L16.0007 11.3333L15.3226 11.8259L15.5816 11.0288L14.9036 10.5361H15.7417L16.0007 9.73895Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3209 10.9348L12.9989 11.4275L13.677 10.9348L13.418 11.732L14.0961 12.2246L13.2579 12.2246L12.9989 13.0218L12.7399 12.2246L11.9017 12.2246L12.5798 11.7319L12.3209 10.9348Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.046 14.0653H10.8841L11.1431 13.2682L11.4021 14.0653L12.2403 14.0652L11.5623 14.558L11.8213 15.3551L11.1431 14.8624L10.4651 15.355L10.724 14.5579L10.046 14.0653Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.046 17.9343L10.724 17.4418L10.465 16.6446L11.1431 17.1373L11.8213 16.6446L11.5623 17.4417L12.2404 17.9344L11.4021 17.9345L11.1431 18.7315L10.8841 17.9343H10.046Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3208 21.0648L12.5797 20.2678L11.9016 19.7751H12.7398L12.9989 18.9779L13.2579 19.775H14.096L13.4179 20.2678L13.6769 21.0648L12.9988 20.5722L12.3208 21.0648Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 22.2606L15.7417 21.4636H14.9036L15.5816 20.9709L15.3226 20.1738L16.0007 20.6663L16.6788 20.1737L16.4198 20.9709L17.0978 21.4636L16.2597 21.4636L16.0007 22.2606Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6804 21.0648L19.0024 20.5722L18.3243 21.0649L18.5833 20.2678L17.9052 19.7751L18.7433 19.775L19.0023 18.9779L19.2614 19.7751H20.0995L19.4215 20.2678L19.6804 21.0648Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9552 17.9344H21.1172L20.8581 18.7316L20.5991 17.9345H19.7609L20.439 17.4418L20.1799 16.6447L20.8581 17.1373L21.5361 16.6447L21.2772 17.4418L21.9552 17.9344Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9552 14.0653L21.2772 14.5579L21.5362 15.3551L20.8581 14.8624L20.18 15.3552L20.439 14.558L19.7609 14.0654L20.5991 14.0652L20.8581 13.2682L21.1172 14.0653H21.9552Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6804 10.9348L19.4215 11.7319L20.0995 12.2246H19.2614L19.0024 13.0218L18.7433 12.2247L17.9052 12.2247L18.5833 11.7319L18.3243 10.9349L19.0024 11.4275L19.6804 10.9348Z",
    fill: "#496E2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDominica);
export default __webpack_public_path__ + "static/media/dominica.186c3b0a.svg";
export { ForwardRef as ReactComponent };